import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { CapsuleI } from "interfaces";
import { AnanseApiService } from "app/services/Ananse/AnanseApiService";
import { Col, Form, Row } from "react-bootstrap";
import FormActions from "components/FormActions";
import Swal from "sweetalert2";
import SelectSearch from "components/Selects/SelectSearch";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Loading from "app/pages/home/components/Loading";
import QRCodesGrid from "./QRCodesGrid";
import { QrCode2 } from "@mui/icons-material";
import { useTranslation } from "_metronic/i18n/language";
import { useThemeApp } from "_metronic/materialUIThemeProvider/ThemeProvider";
import { updateDeviceById } from "app/crud";
import { useSelector } from "react-redux";

const CapsuleForm = () => {
  const { isDarkMode } = useThemeApp();
  const isTheme = isDarkMode ? "dark" : "light";
  const translate = useTranslation();
  const api = new AnanseApiService();
  const schema = Yup.object().shape({
    serialNumber: Yup.string()
      .required(translate("screens.login.validations.required"))
      .nullable(),
    dueDate: Yup.string().required(
      translate("screens.login.validations.required"),
    ),
  });

  const [campaignSelected, setCampaignSelected] = useState(
    {} as { campaignId: number; name: string; obj: { fragranceShots: number } },
  );
  const [loadCampaign, setLoadCampaign] = useState(false);
  const [collections, setCollections] = React.useState<Array<any>>([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [allowSave, setAllowSave] = React.useState(true);
  const [qrCodes, setQRCodes] = React.useState<Array<any>>([]);
  const [showQRCodes, setShowQRCodes] = React.useState(false);
  const [isConfigured, setIsConfigured] = useState<boolean>(false);
  const [remainingTests, setRemainingTests] = useState<number>(0);
  // const [deviceTestsInCampaigns, setDeviceTestsInCampaigns] = React.useState<
  //   any
  // >("");
  const [remainingTestsChecked, setRemainingTestsChecked] = React.useState(
    false,
  );
  const [macAddress, setMacAddress] = React.useState("");
  const [progress, setProgress] = useState(0);
  const [progressSubmit, setProgressSubmit] = useState(0);
  const [valueRemainingShots, setValueRemainingShots] = useState(0);
  const [showCreateDeviceModal, setShowCreateDeviceModal] = useState(false);
  const [newDeviceData, setNewDeviceData] = useState({
    macAddress: "",
    appVersion: "",
    campaignId: null as number | null,
    isDisplay: false,
  });
  const [customerCode, setCustomerCode] = useState("");
  const [deviceId, setDeviceId] = useState(0);

  const authUser = useSelector((state: any) => state.auth.user);

  const getMinDate = () => {
    const today = new Date();
    today.setDate(today.getDate() + 30);
    return today.toISOString().split("T")[0];
  };

  const minDate = getMinDate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    reset,
    control,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      serialNumber: "",
      dueDate: minDate,
    },
  });

  //   const isConfiguredValue = watch(IS_CONFIGURED_FIELD);
  // const isRemainingTests = watch(IS_REMAINING_TESTS_FIELD);

  React.useEffect(() => {
    loadingData();
  }, []);

  const loadingData = async () => {
    try {
      await api.makeHttpRequest({
        method: "GET",
        url: "settings",
      }).then((response) => {
        setCustomerCode(response.customerCode);
      });
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
    }
  };

  const updateDeviceByMacAddress = async () => {
    try {
      await api.makeHttpRequest({
        method: "GET",
        url: `devices/mac/${macAddress}`,
      }).then(async (deviceInfo) => {
        const deviceIdToUpdate = deviceInfo.deviceId;
        const updateResponse = await updateDeviceById(deviceIdToUpdate, {
          isConfigured: isConfigured,
          remainingTests: remainingTests,
        });
        console.log("TESTE: ", updateResponse);
      });
    } catch (error) {
      console.error("Erro ao atualizar device:", error);
    }
  };

  const checkCapsules = async (serialNumber: string, fragranceId: number) => {
    try {
      const response = await api.makeHttpRequest({
        method: "GET",
        url: `capsules/serial/${serialNumber}/${fragranceId}`,
      });
      return { status: false, fragranceId, serialNumber };
    } catch (error) {
      return { status: true, fragranceId, serialNumber };
    }
  };

  const onSubmit = async (data: any) => {
    setLoading(true);
    try {
      const totalItems = collections.filter(value => value.selected).length;
      let processedCount = 0;

      const reqBase = { method: "POST", url: "/capsules" };
      for (const value of collections) {
        const body: CapsuleI = {
          customerCode: customerCode,
          deviceId: deviceId,
          dueDate: data.dueDate,
          fragranceId: parseInt(value.fragranceId),
          remainingShots: valueRemainingShots,
          serialNumber: data.serialNumber,
          performedShots: 0,
        };
        if (value.selected) {
          await api.makeHttpRequest({
            ...reqBase,
            data: body,
          });
          processedCount++;
          const currentProgress = Math.ceil(
            (processedCount / totalItems) * 100,
          ); // Calculating progress as a percentage
          setProgressSubmit(currentProgress);
        }
      }

      if (remainingTestsChecked) {
        await updateDeviceByMacAddress();
      }

      Swal.fire({
        title: translate("defaultMessages.success"),
        text: translate("crudMessages.successText"),
        icon: "success",
      });
    } catch (e) {
      Swal.fire(
        translate(".defaultMessages.error"),
        translate(".screens.user.errors.register"),
        "error",
      );
    } finally {
      setAllowSave(true);
      setLoading(false);
      setProgressSubmit(0); // Reset progress to zero when finished
    }
  };

  const handleReset = () => {
    reset({});
  };
  const handleChangeSeachCampaign = async (campaign: any) => {
    setLoadCampaign(true);
    const url = `/campaigns/${campaign.campaignId}`;
    const reqBase = { method: "GET", url };
    const response = await api.makeHttpRequest({
      ...reqBase,
    });
    handleChangeSelect(response);
    setLoadCampaign(false);
  };
  const handleChangeSelect = (e: any) => {
    const deviceTests = e.deviceTests;
    const newData = e.collection
      .map((item: any) => {
        return {
          fragranceId: item.fragranceId,
          slot: item.slot,
          name: item.fragrance.name,
          selected: false,
        };
      })
      .sort((a: any, b: any) => a.slot - b.slot);
    setCampaignSelected({ campaignId: e.campaignId, name: e.name, obj: e });
    setCollections(newData);
    // setDeviceTestsInCampaigns(deviceTests);
    setRemainingTests(deviceTests || 0);
  };

  const handleSearchDevice = async (e: any) => {
    if (!e || !e.id) {
      // Dispositivo não encontrado, perguntar se deseja criar
      const macAddressInput = e?.inputValue || "";
      if (macAddressInput) {
        const result = await Swal.fire({
          title: "Device não encontrado",
          text: `O MAC Address "${macAddressInput}" não foi encontrado. Deseja criar um novo device?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim, criar",
          cancelButtonText: "Cancelar",
        });

        if (result.isConfirmed) {
          setNewDeviceData({
            ...newDeviceData,
            macAddress: macAddressInput,
          });
          setShowCreateDeviceModal(true);
        }
      }
      return;
    }

    setDeviceId(e.id);
    setMacAddress(e.label);
    handleChangeSeachCampaign(e.obj.campaign);
    setIsConfigured(e.obj.isConfigured || false);
  };

  const handleCreateDevice = async () => {
    try {
      if (!newDeviceData.macAddress || !newDeviceData.campaignId) {
        Swal.fire(
          translate("defaultMessages.error"),
          "Por favor, preencha todos os campos obrigatórios",
          "error"
        );
        return;
      }

      const devicePayload = {
        macAddress: newDeviceData.macAddress,
        appVersion: newDeviceData.appVersion,
        campaignId: newDeviceData.campaignId,
        isDisplay: newDeviceData.isDisplay,
        userId: authUser?.id,
        ownerId: authUser?.id,
      };

      const response = await api.makeHttpRequest({
        method: "POST",
        url: "devices",
        data: devicePayload,
      });

      Swal.fire({
        title: translate("defaultMessages.success"),
        text: "Device criado com sucesso!",
        icon: "success",
      });

      setShowCreateDeviceModal(false);

      // Selecionar automaticamente o device criado
      setDeviceId(response.deviceId);
      setMacAddress(response.macAddress);

      // Carregar a campanha do device criado
      if (response.campaign) {
        handleChangeSeachCampaign(response.campaign);
      }

      setIsConfigured(response.isConfigured || false);

      // Resetar o formulário de criação
      setNewDeviceData({
        macAddress: "",
        appVersion: "",
        campaignId: null,
        isDisplay: false,
      });
    } catch (error) {
      Swal.fire(
        translate("defaultMessages.error"),
        "Erro ao criar device",
        "error"
      );
    }
  };

  const handleCheckboxChange = (itemId: any) => {
    const updatedItems: Array<any> = collections.map((item: any) => {
      if (item.fragranceId === itemId) {
        return { ...item, selected: !item.selected };
      }
      return item;
    });
    setCollections(updatedItems);
  };

  const handleSelectAll = (event: any) => {
    const { checked } = event.target;
    if (checked) {
      const allItems = collections.map((item: any) => {
        return { ...item, selected: true };
      });
      setCollections(allItems);
      setSelectAll(true);
    } else {
      const allItems = collections.map((item: any) => {
        return { ...item, selected: false };
      });
      setCollections(allItems);
      setSelectAll(false);
    }
  };

  const checkItemsInAPI = React.useCallback(async () => {
    setLoading(true);
    const { serialNumber } = getValues();

    if (!serialNumber) {
      setLoading(false);
      return;
    }

    const prepareData = collections.filter(
      item => item.selected && serialNumber,
    );
    const totalItems = prepareData.length;
    let processedCount = 0;

    for (const [index, item] of prepareData.entries()) {
      try {
        delete item.deselect;
        const response = await checkCapsules(
          serialNumber,
          parseInt(item.fragranceId),
        );
        const itemExists = response.status;
        if (!itemExists) {
          prepareData[index].selected = response.status;
          prepareData[index].deselect = response.status;
        }
      } catch (error) {
        // console.error("Erro ao verificar o item na API", error);
      }
      processedCount++;
      const currentProgress = Math.ceil((processedCount / totalItems) * 100); // Calculating progress as a percentage
      setProgress(currentProgress);
    }

    setCollections(prepareData);
    setAllowSave(false);
    setLoading(false);
    setProgress(0); // Reset progress to zero when finished

    const filterP = prepareData.filter(item => item.deselect === false);
    if (filterP.length > 0) {
      Swal.fire({
        title: translate("defaultMessages.error"),
        text: translate("screens.capsule.messages.validatedCapsules"),
        icon: "info",
      });
      setSelectAll(false);
    }
    if (filterP.length === totalItems) {
      setAllowSave(true);
    }
  }, [collections, getValues, translate]);

  React.useEffect(() => {
    const isSelected = collections.filter(
      (item: any) => item.selected === true,
    );
    if (isSelected.length === collections.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
    if (isSelected.length < 1) {
      setAllowSave(true);
      setSelectAll(false);
    }
  }, [collections, allowSave]);

  const checkCampos = React.useCallback(() => {
    const { serialNumber } = getValues();
    const isSelected = collections.filter(
      (item: any) => item.selected === true,
    );
    if (serialNumber && deviceId && isSelected.length > 0) {
      return false;
    }
    return true;
  }, [getValues, collections, deviceId]);

  const handleGenerateQRCodes = (data: any) => {
    const combinedData = collections.map(item => ({
      ...item,
      customerCode: customerCode,
      dueDate: data.dueDate,
      serialNumber: data.serialNumber,
    }));
    setQRCodes(combinedData);
    setShowQRCodes(true);
  };

  useEffect(() => {
    // if (remainingTestsChecked) {
    //   setValueRemainingShots(campaignSelected?.obj?.fragranceShots * 2);
    // } else {
    setValueRemainingShots(campaignSelected?.obj?.fragranceShots);
    // }
  }, [remainingTestsChecked, campaignSelected]);

  const helperText = (text?: string) => (
    <Form.Text className="text-danger">{text}</Form.Text>
  );

  const inputStyle = {
    backgroundColor: "inherit",
    color: isDarkMode ? "#d1d1d1" : "#707070",
  };

  return (
    <>
      <Card className="mt-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <CardContent>
            <Row>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>{translate("labels_code")}</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={translate("screens.capsule.labels.serial")}
                  disabled
                  value={customerCode}
                  style={inputStyle}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  {translate("screens.capsule.labels.serial")} *
                </Form.Label>
                <Form.Control
                  type="text"
                  maxLength={9}
                  minLength={9}
                  placeholder={translate("screens.capsule.labels.serial")}
                  {...register("serialNumber")}
                  style={inputStyle}
                />
                {errors.serialNumber && helperText(errors.serialNumber.message)}
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  {translate("screens.capsule.labels.dueDate")}
                </Form.Label>

                <Controller
                  name="dueDate"
                  control={control}
                  rules={{
                    required: true,
                  }}
                  render={({ field: { onChange, value } }) => (
                    <Form.Control
                      type="date"
                      min={minDate}
                      value={value || minDate}
                      onChange={(value: any) => onChange(value.target.value)}
                      style={inputStyle}
                    />
                  )}
                />
                {errors.dueDate && helperText(errors.dueDate.message)}
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>{translate("screens.device.title")} *</Form.Label>
                <SelectSearch
                  label={translate("screens.device.labels.select")}
                  required={true}
                  className="kt-width-full"
                  url={`devices?FilterString=`}
                  handleChange={(e: any) => {
                    handleSearchDevice(e);
                  }}
                  convertObject={(obj: any) => ({
                    id: obj.deviceId,
                    value: obj.deviceId,
                    label: `${obj.macAddress}`,
                    obj,
                  })}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  {translate("screens.quiz.labels.campaign")} *
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={translate("screens.quiz.labels.campaign")}
                  value={campaignSelected.name}
                  disabled
                  style={inputStyle}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  {translate("screenApp_quiz_messageAvailable")}
                </Form.Label>
                <Form.Control
                  placeholder={`${translate(
                    "screenApp_quiz_messageAvailable",
                  )} (0-999)`}
                  type="text"
                  value={valueRemainingShots}
                  maxLength={3}
                  onChange={e => {
                    const inputValue = e.target.value;

                    if (/^\d*$/.test(inputValue) && Number(inputValue) <= 999) {
                      setValueRemainingShots(Number(inputValue));
                    }
                  }}
                  style={inputStyle}
                />
                <Form.Text className="text-muted">
                  {translate("maxNumber")}
                </Form.Text>
              </Form.Group>
            </Row>
            <Divider color="transparent" />
            {collections.length ? (
              <Box sx={{ flexGrow: 1, marginTop: 2 }}>
                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                >
                  <Checkbox
                    color="success"
                    value="selectAll"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                  <Typography>{translate("labels.selectAll")}</Typography>
                </Stack>
                <Divider />
                <Grid container spacing={2}>
                  {collections.map((item: any) => (
                    <Grid key={item.fragranceId} xs={3}>
                      <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                      >
                        <Checkbox
                          color="success"
                          value={item.selected}
                          checked={item.selected}
                          onChange={() =>
                            handleCheckboxChange(item.fragranceId)
                          }
                        />
                        <Button
                          sx={{
                            cursor: "none",
                            color: isTheme === "dark" ? "#FFF" : "#000",
                          }}
                          variant="text"
                          color="primary"
                          onClick={() => handleCheckboxChange(item.fragranceId)}
                        >
                          {item.slot + " - " + item.name}
                        </Button>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            ) : null}
          </CardContent>
          <CardActions
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "5px",
            }}
            className="border-0"
          >
            <Stack
              sx={{ marginY: "5px" }}
              justifyContent="flex-start"
              alignItems="center"
              direction={{ xs: "column", sm: "row" }}
              spacing={1}
            >
              <Button
                variant="contained"
                color="info"
                disabled={checkCampos()}
                onClick={checkItemsInAPI}
              >
                {translate("screens.capsule.labels.validateCapsules")}
              </Button>
              <Button
                variant="outlined"
                startIcon={<QrCode2 />}
                color="inherit"
                disabled={allowSave}
                onClick={() => handleGenerateQRCodes(getValues())}
              >
                {translate("generate.qrcodes")}
              </Button>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="success"
                      disabled={allowSave}
                      checked={remainingTestsChecked}
                      onChange={(e: any) =>
                        setRemainingTestsChecked(e.target.checked)
                      }
                    />
                  }
                  // label={`${translate(
                  //   "screenApp.capsula.consumptionByTests",
                  // )} : ${deviceTestsInCampaigns}`}
                  label={`${translate(
                    "screenApp.capsula.consumptionByTests",
                  )} :  ${
                    remainingTestsChecked
                      ? translate("screenApp_modal_yes")
                      : translate("screenApp_modal_no")
                  }`}
                />
              </FormGroup>
            </Stack>
            {!allowSave && remainingTestsChecked && (
              <Stack
                style={{
                  width: "60%",
                  display: "flex",
                  flexDirection: "row",
                  flexGrow: "1",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <div className="col-lg-4 col-12">
                  <Form.Check
                    style={{ marginTop: 20 }}
                    type="checkbox"
                    label={`${translate("screens_device_is_configured")} ${
                      isConfigured
                        ? translate("screenApp_modal_yes")
                        : translate("screenApp_modal_no")
                    }`}
                    checked={isConfigured}
                    onChange={event => setIsConfigured(event.target.checked)}
                  />
                </div>

                <Form.Group as={Col} lg="4" xs="12">
                  <Form.Label>
                    {translate("screens_device_remaining_tests")}
                  </Form.Label>
                  <Form.Control
                    // placeholder={`${translate(
                    //   "screenApp_quiz_messageAvailable",
                    // )} (0-999)`}
                    type="number"
                    value={remainingTests | 0}
                    maxLength={3}
                    onChange={(event: any) =>
                      setRemainingTests(Number(event.target.value))
                    }
                    style={inputStyle}
                  />
                  {/* <Form.Text className="text-muted">
                  {translate("maxNumber")}
                </Form.Text> */}
                </Form.Group>
              </Stack>
            )}
          </CardActions>

          <FormActions
            module="capsules"
            disableSubmit={allowSave}
            onReset={handleReset}
          />
        </Form>
      </Card>

      <QRCodesGrid
        name={campaignSelected?.name}
        data={qrCodes}
        open={showQRCodes}
        onClose={() => setShowQRCodes(false)}
      />

      <Dialog
        open={showCreateDeviceModal}
        onClose={() => setShowCreateDeviceModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Criar Novo Device</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 2 }}>
            <TextField
              label="MAC Address"
              value={newDeviceData.macAddress}
              onChange={(e) =>
                setNewDeviceData({ ...newDeviceData, macAddress: e.target.value })
              }
              fullWidth
              required
              disabled
            />
            <TextField
              label="Versão do App"
              value={newDeviceData.appVersion}
              onChange={(e) =>
                setNewDeviceData({ ...newDeviceData, appVersion: e.target.value })
              }
              fullWidth
            />
            <Box>
              <Typography variant="body2" gutterBottom>
                Campanha *
              </Typography>
              <SelectSearch
                label="Selecione uma campanha"
                required={true}
                className="kt-width-full"
                url={`campaigns?FilterString=`}
                handleChange={(e: any) => {
                  setNewDeviceData({ ...newDeviceData, campaignId: e.id });
                }}
                convertObject={(obj: any) => ({
                  id: obj.campaignId,
                  value: obj.campaignId,
                  label: obj.name,
                  obj,
                })}
              />
            </Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={newDeviceData.isDisplay}
                  onChange={(e) =>
                    setNewDeviceData({ ...newDeviceData, isDisplay: e.target.checked })
                  }
                  color="primary"
                />
              }
              label="É Display"
            />
            <Box sx={{ mt: 2, p: 2, bgcolor: "grey.100", borderRadius: 1 }}>
              <Typography variant="body2">
                <strong>User ID:</strong> {authUser?.id || "N/A"}
              </Typography>
              <Typography variant="body2">
                <strong>Owner ID:</strong> {authUser?.id || "N/A"}
              </Typography>
              <Typography variant="body2">
                <strong>Usuário:</strong> {authUser?.nome || authUser?.name || "N/A"}
              </Typography>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowCreateDeviceModal(false)} color="inherit">
            Cancelar
          </Button>
          <Button
            onClick={handleCreateDevice}
            variant="contained"
            color="primary"
          >
            Criar Device
          </Button>
        </DialogActions>
      </Dialog>

      <Loading
        isLoading={loading || loadCampaign}
        msg={loadCampaign ? translate("screens_login_loadingcampaign") : ""}
        progress={progress || progressSubmit}
      />
    </>
  );
};

export default CapsuleForm;
